import React, { FC, useState } from "react";
import { InputNumber, Button, Modal } from "antd";

type BillAmountConfirmationModalProps = {
  isModalVisible: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  text: any;
  showCloseButton?: boolean;
};

const BillAmountConfirmationModal: FC<BillAmountConfirmationModalProps> = ({
  isModalVisible,
  handleOk,
  handleCancel,
  text,
  showCloseButton
}) => {
  return (
    <Modal title={null} visible={isModalVisible} footer={null} width={showCloseButton ? 750 : 1000} onCancel={handleCancel}>
      {text && (
        <>
        <div style={{ marginBottom: 24 }}>{text}</div>
        {!showCloseButton ? <div style={{ marginBottom: 24, textAlign: "center" }}>Please, Upload all your Supporting Documents</div> : <></> }
          </>
      )}

      <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        
        <Button
          onClick={handleOk}
          type="primary"
          style={{
            backgroundColor: "#004C8F",
            color: "#fff",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
        >
          Ok
        </Button>

        {showCloseButton ? <Button
          onClick={handleCancel}
          type="default"
          style={{
            borderColor: "#004C8F",
            color: "#004C8F",
            boxShadow: "0px 2px 8px 0px #00000040",
            minWidth: 100,
          }}
        >
          Cancel
        </Button> : <></>}
      </div>
    </Modal>
  );
};

export default BillAmountConfirmationModal;
